import { TApplicationState } from 'shared/types/redux';

export function breadcrumpsSelector(state: TApplicationState) {
  return state.newbuilding.breadcrumbs;
}
